import { createContext, useContext, useEffect, useState, useCallback } from "react";

const KEY = "panda_date_revealed";
const RevealContext = createContext({ revealed: false, reveal: () => {}, reset: () => {} });

export function RevealProvider({ children }) {
  const [revealed, setRevealed] = useState(() => {
    try {
      return sessionStorage.getItem(KEY) === "1";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      if (revealed) sessionStorage.setItem(KEY, "1");
      else sessionStorage.removeItem(KEY);
    } catch {
      /* ignore */
    }
  }, [revealed]);

  const reveal = useCallback(() => setRevealed(true), []);
  const reset = useCallback(() => setRevealed(false), []);

  return (
    <RevealContext.Provider value={{ revealed, reveal, reset }}>
      {children}
    </RevealContext.Provider>
  );
}

export const useReveal = () => useContext(RevealContext);
